import React, { PureComponent } from "react";
import { Select } from 'element-react';
import { Link } from "react-router-dom";
import "../home1/index.scss";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: {}
    };
  }

  componentDidMount = () => {
    let params = {
      current: 1,
      size: 100,
      parentId: 0,
    };
    return Http.get(Request.getHome(), params, obj => {
      console.log('obj', obj);
      if (obj.code == 200) {
        this.setState({
          data: obj.data.records
        })
      }
    });
  }

  render() {
    const { data } = this.state;

    return (
      <div className="index-mains" style={{ backgroundColor: '#fff' }}>
        <div className="government-affairs">
          <div className="index-header">
            <div className="title">政务服务</div>
          </div>
          <div className="government-wrapper">
            {data && data.length > 0 ? data.map((item, i) => {
              return (
                <div className="box qywh-box" key={i}>
                  <Link to={{ pathname: `qyprotection`, state: { id: item.id,name: item.serviceName } }}>
                    <div className="box-icon">
                      <img src={item.logoUrl} alt="" />
                    </div>
                    <div className="box-title">{item.serviceName}</div>
                    <div className="box-subtitle">{item.describe}</div>
                  </Link>

                </div>
              )
            }):null}
            {/* <div className="box qywh-box">
              <div className="box-icon qywh"></div>
              <div className="box-title">权益维护</div>
              <div className="box-subtitle">为退役军人及军属提供权益保障服务</div>
            </div>
            <div className="box tyaz-box">
              <div className="box-icon tyaz"></div>
              <div className="box-title">退役安置</div>
              <div className="box-subtitle">为军转干部和退休士兵提供安置服务</div>
            </div>
            <div className="box jyfw-box">
              <div className="box-icon jyfw"></div>
              <div className="box-title">就业服务</div>
              <div className="box-subtitle">为复员干部、军转干部和退役士兵提供就业创业服务</div>
            </div>
            <div className="box ydfx-box">
              <div className="box-icon ydfx"></div>
              <div className="box-title">优待抚恤</div>
              <div className="box-subtitle">伤残军人、军属提供经济、教育、医疗等生活方面的帮助</div>
            </div>
            <div className="box jypx-box">
              <div className="box-icon jypx"></div>
              <div className="box-title">教育培训</div>
              <div className="box-subtitle">为退役军人提供相应的职业培训</div>
            </div>
            <div className="box jxaz-box">
              <div className="box-icon jxaz"></div>
              <div className="box-title">军休安置</div>
              <div className="box-subtitle">为离退休士官和无军籍职工提供的安置服务</div>
            </div>
            <div className="box ylby-box">
              <div className="box-icon ylby"></div>
              <div className="box-title">英烈褒扬</div>
              <div className="box-subtitle">传承英烈精神，弘扬红色文化</div>
            </div>
            <div className="box sygz-box">
              <div className="box-icon sygz"></div>
              <div className="box-title">双拥工作</div>
              <div className="box-subtitle">做好拥军优属、拥政爱民工作，巩固军政军民关系</div>
            </div> */}
          </div>
        </div>
      </div >
    );
  }
}
